import React, { useEffect, useState, useRef } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";
import { FcProcess } from "react-icons/fc";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MdTask } from "react-icons/md";
import { FaCloudUploadAlt } from "react-icons/fa";

import { FaCloudDownloadAlt } from "react-icons/fa";
import AssignBookletModal from "../../../components/modal/AssignBookletModal";
import AssignModalComp from "../../../components/modal/AssignModelComp";
import { toast } from "react-toastify";
import axios from "axios";
import { getAllUsers } from "services/common";
import socket from "../../../services/socket/socket";
import Tooltip from "@mui/material/Tooltip";

// Initialize socket connection
// const socket = io(process.env.REACT_APP_API_URL, {
//   transports: ["websocket"], // Force WebSocket only for stability
//   reconnectionAttempts: 5,
//   timeout: 20000,
// });

const TwoLineHeader = ({ title }) => {
  const words = title.split(" ");

  return (
    <div
      style={{
        textAlign: "center",
        whiteSpace: "normal",
        lineHeight: "1.1",
        fontWeight: 700,
      }}
    >
      {words.length > 1 ? (
        <>
          <div>{words[0]}</div>
          <div>{words.slice(1).join(" ")}</div>
        </>
      ) : (
        <div>{title}</div>
      )}
    </div>
  );
};

const ScannerTasks = () => {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showAssignBookletModal, setShowAssignBookletModal] = useState(false);
  const [currentBookletDetails, setCurrentBookletDetails] = useState("");
  const [assignModel, setassignModel] = useState(false);
  const [assignTask, setAssignTask] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const token = localStorage.getItem("token");
  const fileInputRef = useRef(null);
  console.log(currentBookletDetails);

  const processScannerData = async (folderList) => {
    try {
      const token = localStorage.getItem("token");
      const loggedUserId = localStorage.getItem("userId");

      // ✅ get scanner tasks
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/tasks/get/all/scannerTasks`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const allTasks = Array.isArray(res.data?.data) ? res.data.data : [];

      // ✅ filter by user
      const userTasks = allTasks.filter(
        (task) => String(task?.userId?._id) === String(loggedUserId)
      );

      // ✅ create map for fast lookup
      const taskMap = {};
      userTasks.forEach((task) => {
        if (task.subjectCode) {
          taskMap[task.subjectCode] = task;
        }
      });

      // ✅ match socket folders with API
      const mergedData = folderList
        .map((folder) => {
          const task = taskMap[folder.folderName]; // 🔥 match here

          if (!task) return null; // ❌ skip unmatched

          return {
            id: folder._id,

            // ✅ subject info (API priority)
            subjectName: task.subjectName || folder.subjectName,
            folderName: folder.folderName,
            className: folder.className || task.className,

            // ✅ FULL socket data mapping
            scannedFolder: folder.scannedFolder || 0,
            unAllocated: folder.unAllocated || 0,
            allocated: folder.allocated || 0,
            evaluated: folder.evaluated || 0,
            evaluation_pending: folder.evaluation_pending || 0,
          };
        })
        .filter(Boolean); // remove null

      setRows(mergedData);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load scanner data");
    }
  };

  useEffect(() => {
    // Check if the `dark` mode is applied to the `html` element
    const htmlElement = document.body; // `html` element
    const checkDarkMode = () => {
      const isDark = htmlElement.classList.contains("dark");
      setIsDarkMode(isDark);
    };

    // Initial check
    checkDarkMode();

    // Optionally, observe for changes if the theme might toggle dynamically
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(htmlElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  // useEffect(() => {
  //   const fetchTasksBySubjectCode = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_URL}/api/tasks/subjectcode?subjectcode=${currentBookletDetails?.folderName}`
  //       );
  //       console.log("booklet", response.data); // Handle the response data
  //       setAssignTask(response?.data);
  //     } catch (error) {
  //       console.error("Error fetching tasks:", error); // Handle errors
  //     }
  //   };

  //   // Usage
  //   if (currentBookletDetails) {
  //     fetchTasksBySubjectCode();
  //   }
  // }, [currentBookletDetails]);

  useEffect(() => {
    const fetchTasksBySubjectCode = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/tasks/subjectcode?subjectcode=${currentBookletDetails?.folderName}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Task data:", response.data);

        setAssignTask(response?.data || []);
      } catch (error) {
        console.error("Error fetching tasks:", error);
        toast.error("Failed to fetch task data");
      }
    };

    if (currentBookletDetails?.folderName) {
      fetchTasksBySubjectCode();
    }
  }, [currentBookletDetails]);

  useEffect(() => {
    const handleFolderList = (folderList) => {
      // console.log("Initial folder list:", folderList);
      processScannerData(folderList);
      console.log(
        folderList?.map((folder) => ({ ...folder, id: folder?._id }))
      );
    };

    // const handleFolderUpdate = (updatedFolder) => {
    //   console.log("Folder updated:", updatedFolder);
    //   setRows((prevFolders) =>
    //     prevFolders.map((folder) =>
    //       folder._id === updatedFolder._id
    //         ? { ...updatedFolder, id: updatedFolder._id }
    //         : folder
    //     )
    //   );
    // };

    const handleFolderUpdate = (updatedFolder) => {
      console.log("Folder updated:", updatedFolder);

      setRows((prevFolders) =>
        prevFolders.map((folder) => {
          if (folder._id === updatedFolder._id) {
            return {
              ...folder, // keep old subjectName, className etc
              ...updatedFolder, // update only changed fields
              id: folder._id,
            };
          }
          return folder;
        })
      );
    };

    // const handleFolderAdd = (newFolder) => {
    //   // console.log("New folder added:", newFolder);
    //   setRows((prevFolders) => [
    //     ...prevFolders,
    //     { ...newFolder, id: newFolder._id },
    //   ]);
    // };

    const handleFolderAdd = (newFolder) => {
      setRows((prevFolders) => {
        const exists = prevFolders.find((f) => f._id === newFolder._id);

        if (exists) {
          return prevFolders.map((folder) =>
            folder._id === newFolder._id
              ? { ...folder, ...newFolder, id: folder._id }
              : folder
          );
        }

        return [...prevFolders, { ...newFolder, id: newFolder._id }];
      });
    };

    const handleFolderRemove = ({ folderName }) => {
      // console.log("Folder removed:", folderName);
      setRows((prevFolders) =>
        prevFolders?.filter((folder) => folder?.folderName !== folderName)
      );
    };

    // if (!socket.connected) socket.connect();

    // socket.on("connect", () => {
    //   console.log("Socket connected");
    //   socket.emit("request-folder-list");
    // });

    if (!socket.connected) {
      socket.connect();
    } else {
      socket.emit("request-folder-list");
    }

    socket.on("connect", () => {
      console.log("Socket connected");
      socket.emit("request-folder-list");
    });

    // Attach event listeners for real-time updates
    socket.on("folder-list", handleFolderList);
    socket.on("folder-update", handleFolderUpdate);
    socket.on("folder-add", handleFolderAdd);
    socket.on("folder-remove", handleFolderRemove);

    return () => {
      // Disconnect the socket and cleanup listeners

      socket.off("folder-list", handleFolderList);
      socket.off("folder-update", handleFolderUpdate);
      socket.off("folder-add", handleFolderAdd);
      socket.off("folder-remove", handleFolderRemove);
      socket.disconnect();
    };
  }, []);

  console.log(rows);

  const downloadCompletedBooklets = async (subjectCode) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/resultgeneration/download-completed-booklets/${subjectCode}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.size === 0) {
        toast.error("No data available to download");
        return;
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${subjectCode}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error(error);
      toast.error("Failed to download booklets");
    }
  };

  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const pdfFiles = files.filter((file) => file.type === "application/pdf");

    const rarFiles = files.filter(
      (file) =>
        file.type === "application/zip" ||
        file.type === "application/x-zip-compressed"
    );

    // Rule 1: PDF → multiple allowed
    // Rule 2: RAR → only one allowed
    // Rule 3: PDF + RAR together → NOT allowed

    if (rarFiles.length > 1) {
      toast.error("Only one RAR file can be uploaded at a time");
      event.target.value = "";
      return;
    }

    if (rarFiles.length === 1 && pdfFiles.length > 0) {
      toast.error("Cannot upload PDF and RAR together");
      event.target.value = "";
      return;
    }

    // Proceed with upload
    const formData = new FormData();

    files.forEach((file) => {
      formData.append("file", file);
    });
    console.log(currentBookletDetails?.folderName);
    // formData.append("bookletId", currentBookletDetails?._id);
    formData.append("subjectCode", currentBookletDetails?.folderName);
    console.log(formData);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/bookletprocessing/uploadingbooklets`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Upload successful");
    } catch (err) {
      // console.log(err?.response?.data?.message)
      toast.error(err?.response?.data?.message);
    } finally {
      event.target.value = "";
    }
  };

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const response = await getAllUsers();
        setAllUsers(response || []);
      } catch (error) {
        console.error("Error fetching tasks:", error); // Handle errors
      }
    };
    fetchAllUsers();
  }, []);

  // console.log(allUsers)

  // console.log(assignTask)

  const darkTheme = createTheme({
    palette: {
      mode: "dark", // Use 'light' for light mode
      background: {
        default: "#111c44", // Background for dark mode
      },
      text: {
        primary: "#ffffff", // White text for dark mode
      },
    },
  });

  const columns = [
    // 🔽 First 3 columns – smaller

    {
      field: "subjectName", // make sure this matches backend key
      headerName: "Subject Name",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Subject Name" />,
    },
    {
      field: "folderName",
      headerName: "Subject Code",
      flex: 1,
      minWidth: 1 / 2,
      renderHeader: () => <TwoLineHeader title="Subject Code" />,
    },
    {
      field: "className",
      headerName: "Class",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Class" />,
    },
    {
      field: "scannedFolder",
      headerName: "Scanned Data",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Scanned Data" />,
    },

    // Normal size
    {
      field: "unAllocated",
      headerName: "Unallocated",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Unallocated" />,
    },
    {
      field: "allocated",
      headerName: "Allocated",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Allocated" />,
    },
    {
      field: "evaluated",
      headerName: "Evaluated",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Evaluated" />,
    },

    // 🔼 Bigger
    {
      field: "evaluation_pending",
      headerName: "Evaluation Pending",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Evaluation Pending" />,
    },

    {
      field: "upload",
      headerName: "Upload",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Upload" />,
      renderCell: (params) => (
        <>
          <Tooltip title="Upload the zip file" arrow placement="top">
            <div
              className="flex cursor-pointer justify-center rounded px-3 py-2"
              onClick={() => {
                setCurrentBookletDetails(params.row);
                fileInputRef.current.click();
              }}
            >
              <FaCloudUploadAlt className="size-7 text-yellow-600" />
            </div>
          </Tooltip>

          <input
            type="file"
            ref={fileInputRef}
            accept=".pdf,.zip"
            multiple
            className="hidden"
            onChange={handleFileUpload}
          />
        </>
      ),
    },

    // 🔼 Bigger
    {
      field: "processBooklets",
      headerName: "Process Booklets",
      flex: 1,
      minWidth: 1,
      renderHeader: () => <TwoLineHeader title="Process Booklets" />,
      renderCell: (params) => (
        <Tooltip title="Process the booklets" arrow placement="top">
          <div
            className="flex cursor-pointer justify-center rounded px-3 py-2"
            onClick={() => {
              localStorage.removeItem("navigateFrom");
              navigate(`/modulater/process/booklets/${params.row.folderName}`);
            }}
          >
            <FcProcess className="size-7 text-indigo-500" />
          </div>
        </Tooltip>
      ),
    },

    // {
    //   field: "assignTask",
    //   headerName: "Assign Task",
    //   flex: 1,
    //   minWidth: 1,
    //   renderHeader: () => <TwoLineHeader title="Assign Task" />,
    //   renderCell: (params) => (
    //     <Tooltip title="Assign the task to operator" arrow placement="top">
    //       <div
    //         className="flex cursor-pointer justify-center rounded px-3 py-2"
    //         onClick={() => {
    //           setassignModel(true);
    //           setCurrentBookletDetails(params.row);
    //         }}
    //       >
    //         <MdTask className="size-7 text-yellow-600" />
    //       </div>
    //     </Tooltip>
    //   ),
    // },

    // {
    //   field: "downloadbooklet",
    //   headerName: "Download Booklets",
    //   flex: 1,
    //   minWidth: 1,
    //   renderHeader: () => <TwoLineHeader title="Download Booklets" />,
    //   renderCell: (params) => (
    //     <Tooltip title="Download Booklets" arrow placement="top">
    //       <div
    //         className="flex cursor-pointer justify-center rounded px-3 py-2"
    //         onClick={() => {
    //           setShowAssignBookletModal(true);
    //           setCurrentBookletDetails(params.row);
    //         }}
    //       >
    //         <FaCloudDownloadAlt className="size-7 text-yellow-600" />
    //       </div>
    //     </Tooltip>
    //   ),
    // },

    // {
    //   field: "downloadbooklet",
    //   headerName: "Download Booklets",
    //   flex: 1,
    //   minWidth: 1,
    //   renderHeader: () => <TwoLineHeader title="Download Booklets" />,
    //   renderCell: (params) => (
    //     <Tooltip title="Download Booklets" arrow placement="top">
    //       <div
    //         className="flex cursor-pointer justify-center rounded px-3 py-2"
    //         onClick={() => downloadCompletedBooklets(params.row.folderName)}
    //       >
    //         <FaCloudDownloadAlt className="size-7 text-yellow-600" />
    //       </div>
    //     </Tooltip>
    //   ),
    // },
  ];

  return (
    <div className="ml-6 mt-12">
      {isDarkMode ? (
        <ThemeProvider theme={darkTheme}>
          <div style={{ height: "600px", width: "98%" }}>
            <DataGrid
              className="dark:bg-navy-700"
              columns={columns}
              rows={rows}
              slots={{ toolbar: GridToolbar }}
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  fontWeight: 1000,
                  fontSize: "0.8rem",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  color: "#ffffff",
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                },
                "& .MuiDataGrid-cell": {
                  fontSize: "0.75rem",
                  color: "#ffffff",
                  display: "flex",
                  justifyContent: "center",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
                "& .MuiTablePagination-root": {
                  color: "#ffffff",
                },
                "& .MuiDataGrid-footerContainer": {
                  backgroundColor: "#111c44",
                  color: "#ffffff",
                },
                "& .MuiDataGrid-toolbarContainer button": {
                  color: "#ffffff",
                },
                "& .MuiDataGrid-toolbarContainer svg": {
                  fill: "#ffffff",
                },
              }}
            />
          </div>
        </ThemeProvider>
      ) : (
        <div
          style={{ maxHeight: "600px", width: "95%" }}
          className="dark:bg-navy-700"
        >
          <DataGrid
            columns={columns}
            rows={rows}
            slots={{ toolbar: GridToolbar }}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                fontWeight: 1000,
                fontSize: "0.8rem",
                backgroundColor: "#ffffff",
                borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
              },
              "& .MuiTablePagination-root": {
                color: "#000000", // Text color for pagination controls
              },
              "& .MuiDataGrid-cell": {
                fontSize: "0.80rem", // Smaller row text
                color: "#000000", // Cell text color
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.1)", // Optional hover effect
              },
            }}
          />
        </div>
      )}
      {showAssignBookletModal && (
        <AssignBookletModal
          setShowAssignBookletModal={setShowAssignBookletModal}
          currentBookletDetails={currentBookletDetails}
          allUsers={allUsers}
        />
      )}
      {assignModel && (
        <AssignModalComp
          setassignModel={setassignModel}
          currentBookletDetails={currentBookletDetails}
        />
      )}
    </div>
  );
};

export default ScannerTasks;

// import React, { useEffect, useState, useRef } from "react";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { io } from "socket.io-client";
// import { useNavigate } from "react-router-dom";
// import { FcProcess } from "react-icons/fc";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { MdTask } from "react-icons/md";
// import { FaCloudUploadAlt } from "react-icons/fa";

// import { FaCloudDownloadAlt } from "react-icons/fa";
// import AssignBookletModal from "../../../components/modal/AssignBookletModal";
// import AssignModalComp from "../../../components/modal/AssignModelComp";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { getAllUsers } from "services/common";
// import socket from "../../../services/socket/socket";
// import Tooltip from "@mui/material/Tooltip";

// // Initialize socket connection
// // const socket = io(process.env.REACT_APP_API_URL, {
// //   transports: ["websocket"], // Force WebSocket only for stability
// //   reconnectionAttempts: 5,
// //   timeout: 20000,
// // });

// const TwoLineHeader = ({ title }) => {
//   const words = title.split(" ");

//   return (
//     <div
//       style={{
//         textAlign: "center",
//         whiteSpace: "normal",
//         lineHeight: "1.1",
//         fontWeight: 700,
//       }}
//     >
//       {words.length > 1 ? (
//         <>
//           <div>{words[0]}</div>
//           <div>{words.slice(1).join(" ")}</div>
//         </>
//       ) : (
//         <div>{title}</div>
//       )}
//     </div>
//   );
// };

// const ScannerTasks = () => {
//   const [rows, setRows] = useState([]);
//   const navigate = useNavigate();
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const [showAssignBookletModal, setShowAssignBookletModal] = useState(false);
//   const [currentBookletDetails, setCurrentBookletDetails] = useState("");
//   const [assignModel, setassignModel] = useState(false);
//   const [assignTask, setAssignTask] = useState([]);
//   const [allUsers, setAllUsers] = useState([]);
//   const token = localStorage.getItem("token");
//   const fileInputRef = useRef(null);
//   console.log(currentBookletDetails);

//   useEffect(() => {
//     // Check if the `dark` mode is applied to the `html` element
//     const htmlElement = document.body; // `html` element
//     const checkDarkMode = () => {
//       const isDark = htmlElement.classList.contains("dark");
//       setIsDarkMode(isDark);
//     };

//     // Initial check
//     checkDarkMode();

//     // Optionally, observe for changes if the theme might toggle dynamically
//     const observer = new MutationObserver(checkDarkMode);
//     observer.observe(htmlElement, {
//       attributes: true,
//       attributeFilter: ["class"],
//     });

//     return () => observer.disconnect();
//   }, []);

//   // useEffect(() => {
//   //   const fetchTasksBySubjectCode = async () => {
//   //     try {
//   //       const response = await axios.get(
//   //         `${process.env.REACT_APP_API_URL}/api/tasks/subjectcode?subjectcode=${currentBookletDetails?.folderName}`
//   //       );
//   //       console.log("booklet", response.data); // Handle the response data
//   //       setAssignTask(response?.data);
//   //     } catch (error) {
//   //       console.error("Error fetching tasks:", error); // Handle errors
//   //     }
//   //   };

//   //   // Usage
//   //   if (currentBookletDetails) {
//   //     fetchTasksBySubjectCode();
//   //   }
//   // }, [currentBookletDetails]);

//   useEffect(() => {
//     const fetchTasksBySubjectCode = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/api/tasks/subjectcode?subjectcode=${currentBookletDetails?.folderName}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         console.log("Task data:", response.data);

//         setAssignTask(response?.data || []);
//       } catch (error) {
//         console.error("Error fetching tasks:", error);
//         toast.error("Failed to fetch task data");
//       }
//     };

//     if (currentBookletDetails?.folderName) {
//       fetchTasksBySubjectCode();
//     }
//   }, [currentBookletDetails]);

//   useEffect(() => {
//     const handleFolderList = (folderList) => {
//       // console.log("Initial folder list:", folderList);
//       setRows(folderList?.map((folder) => ({ ...folder, id: folder?._id })));
//       console.log(
//         folderList?.map((folder) => ({ ...folder, id: folder?._id }))
//       );
//     };

//     // const handleFolderUpdate = (updatedFolder) => {
//     //   console.log("Folder updated:", updatedFolder);
//     //   setRows((prevFolders) =>
//     //     prevFolders.map((folder) =>
//     //       folder._id === updatedFolder._id
//     //         ? { ...updatedFolder, id: updatedFolder._id }
//     //         : folder
//     //     )
//     //   );
//     // };

//     const handleFolderUpdate = (updatedFolder) => {
//       console.log("Folder updated:", updatedFolder);

//       setRows((prevFolders) =>
//         prevFolders.map((folder) => {
//           if (folder._id === updatedFolder._id) {
//             return {
//               ...folder, // keep old subjectName, className etc
//               ...updatedFolder, // update only changed fields
//               id: folder._id,
//             };
//           }
//           return folder;
//         })
//       );
//     };

//     // const handleFolderAdd = (newFolder) => {
//     //   // console.log("New folder added:", newFolder);
//     //   setRows((prevFolders) => [
//     //     ...prevFolders,
//     //     { ...newFolder, id: newFolder._id },
//     //   ]);
//     // };

//     const handleFolderAdd = (newFolder) => {
//       setRows((prevFolders) => {
//         const exists = prevFolders.find((f) => f._id === newFolder._id);

//         if (exists) {
//           return prevFolders.map((folder) =>
//             folder._id === newFolder._id
//               ? { ...folder, ...newFolder, id: folder._id }
//               : folder
//           );
//         }

//         return [...prevFolders, { ...newFolder, id: newFolder._id }];
//       });
//     };

//     const handleFolderRemove = ({ folderName }) => {
//       // console.log("Folder removed:", folderName);
//       setRows((prevFolders) =>
//         prevFolders?.filter((folder) => folder?.folderName !== folderName)
//       );
//     };

//     // if (!socket.connected) socket.connect();

//     // socket.on("connect", () => {
//     //   console.log("Socket connected");
//     //   socket.emit("request-folder-list");
//     // });

//     if (!socket.connected) {
//       socket.connect();
//     } else {
//       socket.emit("request-folder-list");
//     }

//     socket.on("connect", () => {
//       console.log("Socket connected");
//       socket.emit("request-folder-list");
//     });

//     // Attach event listeners for real-time updates
//     socket.on("folder-list", handleFolderList);
//     socket.on("folder-update", handleFolderUpdate);
//     socket.on("folder-add", handleFolderAdd);
//     socket.on("folder-remove", handleFolderRemove);

//     return () => {
//       // Disconnect the socket and cleanup listeners

//       socket.off("folder-list", handleFolderList);
//       socket.off("folder-update", handleFolderUpdate);
//       socket.off("folder-add", handleFolderAdd);
//       socket.off("folder-remove", handleFolderRemove);
//       socket.disconnect();
//     };
//   }, []);

//   console.log(rows);

//   const downloadCompletedBooklets = async (subjectCode) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/api/resultgeneration/download-completed-booklets/${subjectCode}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response?.data?.size === 0) {
//         toast.error("No data available to download");
//         return;
//       }

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `${subjectCode}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to download booklets");
//     }
//   };

//   const handleFileUpload = async (event) => {
//     const files = Array.from(event.target.files);
//     if (!files.length) return;

//     const pdfFiles = files.filter((file) => file.type === "application/pdf");

//     const rarFiles = files.filter(
//       (file) =>
//         file.type === "application/zip" ||
//         file.type === "application/x-zip-compressed"
//     );

//     // Rule 1: PDF → multiple allowed
//     // Rule 2: RAR → only one allowed
//     // Rule 3: PDF + RAR together → NOT allowed

//     if (rarFiles.length > 1) {
//       toast.error("Only one RAR file can be uploaded at a time");
//       event.target.value = "";
//       return;
//     }

//     if (rarFiles.length === 1 && pdfFiles.length > 0) {
//       toast.error("Cannot upload PDF and RAR together");
//       event.target.value = "";
//       return;
//     }

//     // Proceed with upload
//     const formData = new FormData();

//     files.forEach((file) => {
//       formData.append("file", file);
//     });
//     console.log(currentBookletDetails?.folderName);
//     // formData.append("bookletId", currentBookletDetails?._id);
//     formData.append("subjectCode", currentBookletDetails?.folderName);
//     console.log(formData);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/api/bookletprocessing/uploadingbooklets`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       toast.success("Upload successful");
//     } catch (err) {
//       // console.log(err?.response?.data?.message)
//       toast.error(err?.response?.data?.message);
//     } finally {
//       event.target.value = "";
//     }
//   };

//   useEffect(() => {
//     const fetchAllUsers = async () => {
//       try {
//         const response = await getAllUsers();
//         setAllUsers(response || []);
//       } catch (error) {
//         console.error("Error fetching tasks:", error); // Handle errors
//       }
//     };
//     fetchAllUsers();
//   }, []);

//   // console.log(allUsers)

//   // console.log(assignTask)

//   const darkTheme = createTheme({
//     palette: {
//       mode: "dark", // Use 'light' for light mode
//       background: {
//         default: "#111c44", // Background for dark mode
//       },
//       text: {
//         primary: "#ffffff", // White text for dark mode
//       },
//     },
//   });

//   const columns = [
//     // 🔽 First 3 columns – smaller

//     {
//       field: "subjectName", // make sure this matches backend key
//       headerName: "Subject Name",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Subject Name" />,
//     },
//     {
//       field: "folderName",
//       headerName: "Subject Code",
//       flex: 1,
//       minWidth: 1 / 2,
//       renderHeader: () => <TwoLineHeader title="Subject Code" />,
//     },
//     {
//       field: "className",
//       headerName: "Class",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Class" />,
//     },
//     {
//       field: "scannedFolder",
//       headerName: "Scanned Data",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Scanned Data" />,
//     },

//     // Normal size
//     {
//       field: "unAllocated",
//       headerName: "Unallocated",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Unallocated" />,
//     },
//     {
//       field: "allocated",
//       headerName: "Allocated",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Allocated" />,
//     },
//     {
//       field: "evaluated",
//       headerName: "Evaluated",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Evaluated" />,
//     },

//     // 🔼 Bigger
//     {
//       field: "evaluation_pending",
//       headerName: "Evaluation Pending",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Evaluation Pending" />,
//     },

//     {
//       field: "upload",
//       headerName: "Upload",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Upload" />,
//       renderCell: (params) => (
//         <>
//           <Tooltip title="Upload the zip file" arrow placement="top">
//             <div
//               className="flex cursor-pointer justify-center rounded px-3 py-2"
//               onClick={() => {
//                 setCurrentBookletDetails(params.row);
//                 fileInputRef.current.click();
//               }}
//             >
//               <FaCloudUploadAlt className="size-7 text-yellow-600" />
//             </div>
//           </Tooltip>

//           <input
//             type="file"
//             ref={fileInputRef}
//             accept=".pdf,.zip"
//             multiple
//             className="hidden"
//             onChange={handleFileUpload}
//           />
//         </>
//       ),
//     },

//     // 🔼 Bigger
//     {
//       field: "processBooklets",
//       headerName: "Process Booklets",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Process Booklets" />,
//       renderCell: (params) => (
//         <Tooltip title="Process the booklets" arrow placement="top">
//           <div
//             className="flex cursor-pointer justify-center rounded px-3 py-2"
//             onClick={() => {
//               localStorage.removeItem("navigateFrom");
//               navigate(`/admin/process/booklets/${params.row.folderName}`);
//             }}
//           >
//             <FcProcess className="size-7 text-indigo-500" />
//           </div>
//         </Tooltip>
//       ),
//     },

//     {
//       field: "assignTask",
//       headerName: "Assign Task",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Assign Task" />,
//       renderCell: (params) => (
//         <Tooltip title="Assign the task to operator" arrow placement="top">
//           <div
//             className="flex cursor-pointer justify-center rounded px-3 py-2"
//             onClick={() => {
//               setassignModel(true);
//               setCurrentBookletDetails(params.row);
//             }}
//           >
//             <MdTask className="size-7 text-yellow-600" />
//           </div>
//         </Tooltip>
//       ),
//     },

//     // {
//     //   field: "downloadbooklet",
//     //   headerName: "Download Booklets",
//     //   flex: 1,
//     //   minWidth: 1,
//     //   renderHeader: () => <TwoLineHeader title="Download Booklets" />,
//     //   renderCell: (params) => (
//     //     <Tooltip title="Download Booklets" arrow placement="top">
//     //       <div
//     //         className="flex cursor-pointer justify-center rounded px-3 py-2"
//     //         onClick={() => {
//     //           setShowAssignBookletModal(true);
//     //           setCurrentBookletDetails(params.row);
//     //         }}
//     //       >
//     //         <FaCloudDownloadAlt className="size-7 text-yellow-600" />
//     //       </div>
//     //     </Tooltip>
//     //   ),
//     // },

//     {
//       field: "downloadbooklet",
//       headerName: "Download Booklets",
//       flex: 1,
//       minWidth: 1,
//       renderHeader: () => <TwoLineHeader title="Download Booklets" />,
//       renderCell: (params) => (
//         <Tooltip title="Download Booklets" arrow placement="top">
//           <div
//             className="flex cursor-pointer justify-center rounded px-3 py-2"
//             onClick={() => downloadCompletedBooklets(params.row.folderName)}
//           >
//             <FaCloudDownloadAlt className="size-7 text-yellow-600" />
//           </div>
//         </Tooltip>
//       ),
//     },
//   ];

//   return (
//     <div className="ml-6 mt-12">
//       {isDarkMode ? (
//         <ThemeProvider theme={darkTheme}>
//           <div style={{ height: "600px", width: "98%" }}>
//             <DataGrid
//               className="dark:bg-navy-700"
//               columns={columns}
//               rows={rows}
//               slots={{ toolbar: GridToolbar }}
//               sx={{
//                 "& .MuiDataGrid-columnHeaders": {
//                   fontWeight: 1000,
//                   fontSize: "0.8rem",
//                   backgroundColor: "rgba(255, 255, 255, 0.1)",
//                   color: "#ffffff",
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 10,
//                 },
//                 "& .MuiDataGrid-cell": {
//                   fontSize: "0.75rem",
//                   color: "#ffffff",
//                   display: "flex",
//                   justifyContent: "center",
//                 },
//                 "& .MuiDataGrid-row:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 0.1)",
//                 },
//                 "& .MuiTablePagination-root": {
//                   color: "#ffffff",
//                 },
//                 "& .MuiDataGrid-footerContainer": {
//                   backgroundColor: "#111c44",
//                   color: "#ffffff",
//                 },
//                 "& .MuiDataGrid-toolbarContainer button": {
//                   color: "#ffffff",
//                 },
//                 "& .MuiDataGrid-toolbarContainer svg": {
//                   fill: "#ffffff",
//                 },
//               }}
//             />
//           </div>
//         </ThemeProvider>
//       ) : (
//         <div
//           style={{ maxHeight: "600px", width: "95%" }}
//           className="dark:bg-navy-700"
//         >
//           <DataGrid
//             columns={columns}
//             rows={rows}
//             slots={{ toolbar: GridToolbar }}
//             sx={{
//               "& .MuiDataGrid-columnHeaders": {
//                 fontWeight: 1000,
//                 fontSize: "0.8rem",
//                 backgroundColor: "#ffffff",
//                 borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
//               },
//               "& .MuiTablePagination-root": {
//                 color: "#000000", // Text color for pagination controls
//               },
//               "& .MuiDataGrid-cell": {
//                 fontSize: "0.80rem", // Smaller row text
//                 color: "#000000", // Cell text color
//               },
//               "& .MuiDataGrid-row:hover": {
//                 backgroundColor: "rgba(0, 0, 0, 0.1)", // Optional hover effect
//               },
//             }}
//           />
//         </div>
//       )}
//       {showAssignBookletModal && (
//         <AssignBookletModal
//           setShowAssignBookletModal={setShowAssignBookletModal}
//           currentBookletDetails={currentBookletDetails}
//           allUsers={allUsers}
//         />
//       )}
//       {assignModel && (
//         <AssignModalComp
//           setassignModel={setassignModel}
//           currentBookletDetails={currentBookletDetails}
//         />
//       )}
//     </div>
//   );
// };

// export default ScannerTasks;
